"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Request = require("./_request-api");
var constants_1 = require("../data/constants");
var preregister = function () {
    return Request.sendPost(constants_1.endpoints.api + "/preregistered_cards");
};
var tokenize = function (cardNumber, cardMonth, cardYear, cardCvx, data) {
    var headers = {
        "Content-Type": "text/plain",
    };
    var params = {
        data: data.preregistration_data,
        accessKeyRef: data.access_key,
        cardNumber: cardNumber,
        cardCvx: cardCvx,
        cardExpirationDate: [
            cardMonth,
            cardYear,
        ].join(""),
    };
    return axios_1.default({
        url: data.card_registration_url,
        method: "POST",
        headers: headers,
        data: Object.keys(params).map(function (k) { return [k, params[k]].join("="); }).join("&"),
    }).then(function (response) { return response.data; });
};
var finalize = function (preregisteredCard, token) {
    return Request.sendPut(constants_1.endpoints.api + "/cards/" + preregisteredCard.id, {
        registration_data: token,
    });
};
var create = function (cardNumber, month, year, cvx) {
    return preregister()
        .then(function (preregisteredCard) {
        return tokenize(cardNumber, month, year, cvx, preregisteredCard)
            .then(function (token) { return finalize(preregisteredCard, token); });
    });
};
exports.create = create;
//# sourceMappingURL=card.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/card.js
// module id = 886
// module chunks = 3